export default __webpack_public_path__ + "static/setting-b4557a73b8838c196ea448525718a191.png";